import React from 'react'
import { connect } from 'react-redux'
import { Button, List, Form } from 'semantic-ui-react'
import { getProducts } from '../../actions/actionCreators'
import { backendService } from '../../services/backendService'
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { NotificationManager } from 'react-notifications';
import SubscriptionItem from '../User/SubscriptionItem'
import CardForm from './CardForm'
import SubscriptionChangeConfirmationDialog from './SubscriptionChangeConfirmationDialog';
import { elapsed, computeTrialDays } from './../../services/defaults'

class SubscriptionChangeForm extends React.Component {

  constructor(props) {
    super()
    this.state = {          
      modalPlanUpdateOpenConfirm: false,
      customer: props.state.customer ? props.state.customer : null,
      lastSubscriptionIndex: props.state.lastSubscriptionIndex ? props.state.lastSubscriptionIndex : 0,
      subscription: props.state.subscription ? props.state.subscription : null,
      subscriptionItemsIndex: props.state.subscriptionItemsIndex ? props.state.subscriptionItemsIndex : 0,
      subscriptionItem: props.state.subscriptionItem ? props.state.subscriptionItem : null,    
      selectedPlanId: props.state.planId ? props.state.planId : null,
      currentPlanId: props.state.planId ? props.state.planId : null,  
      currentPlanName: props.state.planName ? props.state.planName : null,  
      product_id: props.state.product_id ? props.state.product_id : null,
      product_details: props.state.product_details ? props.state.product_details: null,
      product_prices: props.state.product_prices ? props.state.product_prices: [],
      planChanged: props.planChanged,
      paymentMethodChanged: props.paymentMethodChanged,
      paymentMethods: props.state.paymentMethods ? props.state.paymentMethods : [],
      paymentMethod: props.state.paymentMethod ? props.state.paymentMethod : null,
      trial_expires_at: props.auth.user.trial_expires_at ? props.auth.user.trial_expires_at : null,
      trial_days: computeTrialDays(props.auth.user.trial_expires_at)  
    }
  }

  handlePlanChange = (e, { value }) => {
    this.setState({errors: {...this.state.errors}})    
    this.setState({selectedPlanId: value })
  }

  componentDidMount = async () => {
    if (!this.state.product_id)
      NotificationManager.error(Translate(this.context, 'generic_fail_message'))
    else if (!this.state.product_prices || this.state.product_prices.length === 0)
      NotificationManager.error(Translate(this.context, 'generic_fail_message'))        
  } 

  componentDidUpdate = async (newProps) => {
    if (newProps.state.paymentMethods !== this.state.paymentMethods) {
      this.setState( { paymentMethods: newProps.state.paymentMethods } );
    }
    if (newProps.state.paymentMethod !== this.state.paymentMethod) {
      this.setState( { paymentMethod: newProps.state.paymentMethod } );
    }
  }

  askForPlanUpdateConfirm = () => { 
    this.setState({ modalPlanUpdateOpenConfirm: true }) 
  }

  paymentMethodUpdateSuccess = async (payment_method) => { 
    if (this.state.paymentMethodChanged)
      await this.state.paymentMethodChanged();
    this.setState({ paymentMethod: payment_method, modalPlanUpdateOpenConfirm: true }) 
    return true
  }

  closePlanUpdateConfirm = async () => { 
    this.setState({ modalPlanUpdateOpenConfirm: false , processing: false }) 
  }

  createSubscription = async ( lawyerId, paymentMethodId ) => {    
    this.setState({processing: true})        
    let req = { planId: this.state.selectedPlanId, trial_days: this.state.trial_days }
    if (paymentMethodId) 
        req.paymentMethodId = paymentMethodId    
    if (!lawyerId)
      return null;
    try {
      const resp = await backendService.post('/api/lawyers/' + lawyerId + '/subscriptions', req);
      if (resp && resp.data && resp.data.success === true)
        return resp.data.subscription
      else {     
        return null
      }    
    } catch(error) {    
      console.error(error);
      return null
    }
  }

  updateSubscription = async ( lawyerId, paymentMethodId, subscriptionId, subscriptionItemId ) => { 
    this.setState({processing: true})   
    try { 
      if(!paymentMethodId) { 
        return null;
      }

      if (!subscriptionId || !lawyerId || !subscriptionItemId)
        return null;

      const newPlanId = this.state.selectedPlanId   
      if (newPlanId !== this.state.currentPlanId) {
        const response = await backendService.put('/api/lawyers/' + lawyerId + '/subscriptions/' + subscriptionId + '/plan', { paymentMethodId, subscriptionItemId, planId: newPlanId, trial_days: this.state.trial_days })
        if (response.data && response.data.success === true ) {
          return response.data.subscription
        } else {
          return null
        }
      } else {
        return this.state.subscription
      }
    } catch (exc) {
      console.error(exc);
      return null;
    }
  }

  confirmSubscriptionUpdate = () => {
    this.state.planChanged && this.state.planChanged()
  }

  render() {
    const cardStripe = this.state.paymentMethods && this.state.paymentMethods.length > 0 && this.state.paymentMethod ?  this.state.paymentMethods.find( (element) => { return element.id === this.state.paymentMethod } ): null 
    const card = cardStripe ?            
        <Form.Input   
          type="text" 
          name="card" 
          placeholder=''
          value={`**** **** **** ${cardStripe.card.last4}`} 
          action={{
            style: {background: '#3e4ad4', color: 'white'},
            icon: 'payment',
            content: cardStripe.card.brand,
            labelPosition: 'left',
            onClick: null,
            disabled: true
          }}
        /> 
    : null
    return (      
        <div>
          <Form >
            <Form.Field>
              <List celled align='left'>
                {this.state.product_prices.map((price) =>
                  <SubscriptionItem key={price.id} 
                                    handlePlanChange={this.handlePlanChange} 
                                    plan={price} 
                                    selected={this.state.selectedPlanId === price.id} 
                                    isCurrentPlan={this.state.currentPlanId === price.id} 
                                    trialDays={this.state.trial_days}
                  />                              
                )}                        
              </List>                              
            </Form.Field>
            { card ? 
                <>
                  <p className='text-center'><Text tid='subscription_will_be_paid_on' /></p>
                  {card}
                  <Button style={{width: '100%'}} disabled={this.state.currentPlanId === this.state.selectedPlanId || !this.state.selectedPlanId} onClick={this.askForPlanUpdateConfirm.bind(this)} className='lisia-blue'><Text tid='subscribe' /></Button>                   
                </>
              :                
                <>
                  <p className='text-center'><b><Text tid='resource_missing' /></b></p>
                  <CardForm 
                    handleResult={this.paymentMethodUpdateSuccess.bind(this)} 
                    button_text='subscribe' 
                    show_header={false} 
                    button_disabled={!this.state.selectedPlanId || this.state.selectedPlanId === this.state.currentPlanId} 
                    customerId={this.props.auth.user.customerid}
                    />
                </>
            }
          </Form>       
          <SubscriptionChangeConfirmationDialog 
              lawyer_id={this.props.auth.user.id}
              is_open={this.state.modalPlanUpdateOpenConfirm} 
              closeModal={this.closePlanUpdateConfirm.bind(this)} 
              createSubscription={this.createSubscription.bind(this)}
              updateSubscription={this.updateSubscription.bind(this)}
              confirmSubscriptionUpdate={this.confirmSubscriptionUpdate.bind(this)}
              button_disabled={this.state.processing} 
              user_name={this.props.auth.user.name}
              payment_method={this.state.paymentMethod}
              current_subscription={this.state.subscription}
              current_subscription_item={this.state.subscriptionItem}
          />                          
        </div> 
    )

  }
}

SubscriptionChangeForm.contextType = LanguageContext;

const mapStateToProps = (state) => ({
  stripeState: state.stripeState,
  auth: state.auth,
  usage: state.articles.usage !== undefined ? state.articles.usage : false,
  dispatchError: state.articles.error !== undefined ? state.articles.error : false,
  errorMessage: state.articles.message !== undefined ? state.articles.message : false,
  articles: state.articles !== undefined ? state.articles : false
})

export default connect(mapStateToProps)(SubscriptionChangeForm)